import React, { ElementType } from "react";
import ModalHeader from "./ModalHeader";
import { ModalBody, ModalFooter, ModalTitle } from "./ModalContent";
import { ModalContextProvider } from "./ModalContext";

interface ModalProps {
    show?: any;
    onHide?: any;
    className?: string;
    children: React.ReactNode;
    as?: ElementType;
    id?: string;
    placement?: string;
    dialogClassName?: string;
    backdropClassName?: string;
}

const Modal = ({ show, onHide, children, className, placement, id, dialogClassName, backdropClassName, as: Component = "div", ...props }: ModalProps) => {

    return (
        <React.Fragment >
            <div
                {...props}
                id={id ? id : "defaultModal"}
                aria-hidden={!show}
                className={`fixed inset-0 z-drawer flex items-center justify-center p-4 overflow-y-auto transition-opacity duration-200 ease-out ${show ? "opacity-100" : "opacity-0 pointer-events-none"} ${className ? className : ''}`}
            >
                <ModalContextProvider show={show} onHide={onHide}>
                    <Component
                        className={`max-w-full max-h-[calc(100vh-2rem)] overflow-hidden rounded-2xl border border-slate-200 dark:border-zink-500 bg-white dark:bg-zink-600 shadow-2xl shadow-slate-900/10 dark:shadow-black/40 transition-all duration-200 ease-[cubic-bezier(0.34,1.56,0.64,1)] ${show ? "translate-y-0 scale-100" : "translate-y-3 scale-95"} ${dialogClassName ? dialogClassName : ''}`}
                    >
                        {children}
                    </Component>
                </ModalContextProvider>
            </div>
            <div onClick={onHide} className={`fixed inset-0 bg-slate-900/40 dark:bg-zink-900/60 ${backdropClassName ? backdropClassName : "backdrop-blur-sm"} z-[1049] transition-opacity duration-200 ${show ? "opacity-100" : "opacity-0 pointer-events-none"}`} id="backDropDiv"></div>
        </React.Fragment>
    );
};

export default Object.assign(Modal, {
    Header: ModalHeader,
    Title: ModalTitle,
    Body: ModalBody,
    Footer: ModalFooter
});